import { Viewer as ViewerBase, } from '@seddi/ui-three-viewer';
import log from 'loglevel';
import { degreeToRadian } from '@/core/units';
import { computeRotationFromCamera, getEnvironmentRotation } from '@/viewer/environment';
import { AppViewerTool } from './appViewerTool';
export class Viewer extends ViewerBase {
    constructor(props) {
        super(props);
        this.cameraChangeListener = null;
        const handleResourceChangeBase = this.handleResourceChange;
        this.handleResourceChange = ((event) => {
            handleResourceChangeBase(event);
            if (event.status !== 'ready')
                return;
            const tool = this.tool;
            switch (event.kind) {
                case 'GarmentGeometry': {
                    const garmentGeometry = this.resources.findGarmentGeometry(event.id);
                    tool.updateGarmentGeometry(garmentGeometry);
                    tool.updateLogos(this.props.logos);
                    tool.updateSelection(this.props.selectedGraphicId);
                    break;
                }
                case 'Model': {
                    const model = this.resources.findModel(event.id);
                    tool.updateModel(model);
                    tool.updateLogos(this.props.logos);
                    tool.updateSelection(this.props.selectedGraphicId);
                    break;
                }
            }
        });
    }
    componentDidMount() {
        super.componentDidMount();
        log.info('Scene is loading');
        const { camera, props } = this;
        camera.parent = null;
        const canvas = this.canvasRef.current;
        const enableRaycast = props.showGraphicsPanel;
        const enableTransform = enableRaycast;
        const tool = new AppViewerTool({
            camera,
            canvas,
            dispatch: props.dispatch,
            enableRaycast,
            enableTransform,
            idleAnimationMode: this.props.idleAnimationMode,
        });
        this.tool = tool;
        // Create editor tool event listeners
        const cameraChangeListener = (event) => {
            // Compute environment rotation from camera.
            const cameraRotation = computeRotationFromCamera(event);
            // Update environment rotation.
            const { props, scene } = this;
            const environmentRotation = degreeToRadian(getEnvironmentRotation(props.scene));
            scene.environmentRotation.set(0, cameraRotation + environmentRotation, 0);
        };
        tool.addEventListener('cameraChange', cameraChangeListener);
        this.cameraChangeListener = cameraChangeListener;
        tool.updateRegions(props.logoRegions);
        tool.updateLogos(props.logos);
        tool.updateSelection(props.selectedGraphicId);
        tool.updateHover(props.hoverGraphicId);
    }
    shouldComponentUpdate(nextProps) {
        const isUpdate = super.shouldComponentUpdate(nextProps);
        const { props } = this;
        if (props.hoverGraphicId !== nextProps.hoverGraphicId ||
            props.logoRegions !== nextProps.logoRegions ||
            props.logos !== nextProps.logos ||
            props.selectedGraphicId !== nextProps.selectedGraphicId ||
            props.showGraphicsPanel !== nextProps.showGraphicsPanel) {
            return true;
        }
        return isUpdate;
    }
    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps, this.state);
        const tool = this.tool;
        const { props } = this;
        if (props.logoRegions !== prevProps.logoRegions) {
            tool.updateRegions(props.logoRegions);
        }
        if (props.logos !== prevProps.logos) {
            tool.updateLogos(props.logos);
        }
        if (props.selectedGraphicId !== prevProps.selectedGraphicId) {
            tool.updateSelection(props.selectedGraphicId);
        }
        if (props.hoverGraphicId !== prevProps.hoverGraphicId) {
            tool.updateHover(props.hoverGraphicId);
        }
    }
}
